import React, { useState } from "react";
import { Element } from "react-scroll";

function Questions() {
  // Questions data array
  const questions = [
    {
      id: 1,
      question: "What are the background features in this app?",
      answer:
        "In this app, you get the option to remove the background, add the photo to different sets of backgrounds, or use custom backgrounds.",
    },
    {
      id: 2,
      question: "How to save photos that are edited?",
      answer:
        "App automatically saves all your edits in my collection where you can save directly to your phone.",
    },
    {
      id: 3,
      question: "How to use a custom filter option?",
      answer:
        "pixellab has created a unique feature called custom filter where you can create your own filter by adjusting the color, brightness, contrast, tint, saturation, intensity, warmth, fade, exposure, shadows, and much more. To create professional photos.",
    },
    {
      id: 4,
      question: "How to edit quotes?",
      answer:
        "pixellab has quotes divided into categories so that you can pick as per your mood. Quotes available are in English, Hindi, Gujarati, Maharani, Bangla, and Kannad. Simply add quotes to your photo in the editing section and adjust according to your need.",
    },
    {
      id: 5,
      question: "How to resize a photo?",
      answer:
        "Click on the editing option then choose a photo you want to resize. Using the app you can resize any photo to square, 2:3, 3:5, 3:4, or resize as per social media platforms.",
    },
    {
      id: 6,
      question: "How to share my photo?",
      answer:
        "After editing you can directly share your photo to your preferred social networking platform from the app.",
    },
    {
      id: 7,
      question: "How to add tattoo stickers?",
      answer:
        "It's very easy to add an editing option, choose your photo, and add a tattoo sticker. You can resize the sticker as per your preference.",
    },
  ];

  // State to manage toggle for each question
  const [openQuestions, setOpenQuestions] = useState({});

  // Toggle handler for each question
  const toggleQuestion = (id) => {
    setOpenQuestions((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  return (
    <div>
      <div id="questions">
        <div className="que_container">
          <div
            data-bs-toggle="collapse"
            href="#collapseExample"
            role="button"
            aria-expanded="false"
          >
            <div className="que_title">Frequently Asked Questions</div>
          
            {/* Mapping over the questions array */}
            {questions.map((q) => (
              <div
                key={q.id}
                className="question-section"
                onClick={() => toggleQuestion(q.id)}
              >
                <div className="circle_icon">
                  <i
                    className={
                      openQuestions[q.id]
                        ? "fa fa-chevron-up"
                        : "fa fa-chevron-down"
                    }
                  ></i>
                  <span className="ml_30">{q.question}</span>
                </div>
                {openQuestions[q.id] && (
                  <div className="card card-body">{q.answer}</div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Questions;
